import React from 'react'
import LabshighBG from '../../../../assets/bg/pc/bg_labshigh.png'
import LabshighContent from '../../../../assets/bg/pc/bg_labshigh_content_01.png'
import Float from '../../../../styles/float/Float'
import Outer from '../../../../styles/outer/Outer'

const LabshighPCComponent: React.FC<any> = () => {
  return (
    <Outer>
      <img src={LabshighBG} />
      <Float left={'16.3%'} top={181} w={'67.39%'}>
        <img src={LabshighContent} />
      </Float>
    </Outer>
  )
}

export default LabshighPCComponent
